<template>
    <div class="editor">
        <div class="editor-nav">
            <!-- 编辑器: 标题栏 -->
            <div class="title-bar">{{curItem.cname}}</div>
            <div class="content" style="margin-top: 20px">
                <div class="numbox block-box">
                    <div class="block-item">
                        <div class="label" :span="4">
                            模板名称
                        </div>
                        <el-input v-model="pageName"></el-input>
                    </div>
                </div>
                <div class="numbox block-box">
                    <div class="block-item">
                        <div class="label" :span="4">
                            页面标题
                        </div>
                        <el-input v-model="curItem.title" ></el-input>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "page-title",
        props: {
            // 当前选中的元素
            curItem: {
                type: Object,
                default: {}
            },
            pageName: {
                type: String,
                default: ''
            }
        },
        watch: {
            pageName: {
                handler(nVal, oVal) {
                    this.$emit('changePageName', nVal)
                },
                immediate: true,
                deep: true
            }
        },
        created() {
            console.log(this.curItem)
        }
    }
</script>

<style scoped lang="less">
    .editor {
        .title-bar {
            width: 100%;
            height: 45px;
            line-height: 45px;
            padding-left: 24px;
            color: #000;
            border-radius: 4px;
            border-bottom: 1px solid #eee;
            font-size: 14px;
        }
    }
    /deep/ .slider-box .el-slider__input{
        width: 80px;
    }
    /deep/ .color-box{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .color-item{
            margin-left: 15px;
            .span{
                margin-left: 5px;
                color: #999;
                font-size: 13px;
                cursor: pointer;
            }
        }
    }
    .editor-nav{
        width: 100%;
        box-sizing: border-box;
        padding: 0 15px;
        /deep/ .el-tabs__nav-scroll {
            padding: 0 30px;
            .el-tabs__item{
                padding-left: 45px;
                padding-right: 45px;
            }
        }
    }
    /deep/ .block-box {
        .block-item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            .label{
                font-size: 14px;
                color: #999999;
                span{
                    margin-left: 10px;
                    color: #333;
                }
            }
        }
    }
</style>
